import { namespaces } from '@common'

export const namespace = namespaces.insurance.value
export const schema = 'tiiSchema'
export const backendDocType = 'Tii'
export const docPrivilege = 'insurance'
